import { render } from "./StorePerformance.vue?vue&type=template&id=2d7fe3cb&scoped=true"
import script from "./StorePerformance.vue?vue&type=script&lang=js"
export * from "./StorePerformance.vue?vue&type=script&lang=js"

import "./StorePerformance.vue?vue&type=style&index=0&id=2d7fe3cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7fe3cb"]])

export default __exports__